/** Current in-app location, to be round-tripped through the MSAL login redirect. */
export function getCurrentReturnPath(): string {
  const { pathname, search, hash } = window.location;
  return `${pathname}${search}${hash}`;
}

/**
 * Returns the path from the MSAL `state` only if it is a same-origin, in-app path.
 * Rejects anything that could navigate elsewhere (`//host`, `/\host`, `https://host`).
 */
export function getSafeReturnPath(state?: string | null): string | null {
  if (!state || state === '/') return null;
  if (!state.startsWith('/') || state.startsWith('//') || state.startsWith('/\\')) return null;
  return state;
}
